import {
  type ExpenseInvoiceDraftBlockReasonDto,
  ExpenseInvoiceDraftBlockReason,
  ExpenseInvoiceStatus,
} from '../Types/expenseInvoice.types';

export const EXPENSE_INVOICE_DRAFT_BLOCK_REASON_LABELS: Record<
  ExpenseInvoiceDraftBlockReason,
  string
> = {
  [ExpenseInvoiceDraftBlockReason.None]: 'Brak przyczyny blokady',
  [ExpenseInvoiceDraftBlockReason.SupplierApprovalPending]:
    'Oczekuje na zatwierdzenie dostawcy',
  [ExpenseInvoiceDraftBlockReason.ImportDataReviewRequired]:
    'Wymaga ręcznej weryfikacji danych',
};

export const parseExpenseInvoiceDraftBlockReason = (
  value: ExpenseInvoiceDraftBlockReasonDto | undefined
): ExpenseInvoiceDraftBlockReason | undefined => {
  const normalizedValue = String(value ?? '').trim().toLowerCase();

  if (normalizedValue.length === 0) {
    return undefined;
  }

  if (normalizedValue === 'none') {
    return ExpenseInvoiceDraftBlockReason.None;
  }

  if (
    normalizedValue === 'supplierapprovalpending' ||
    normalizedValue === 'supplier_approval_pending'
  ) {
    return ExpenseInvoiceDraftBlockReason.SupplierApprovalPending;
  }

  if (
    normalizedValue === 'importdatareviewrequired' ||
    normalizedValue === 'import_data_review_required'
  ) {
    return ExpenseInvoiceDraftBlockReason.ImportDataReviewRequired;
  }

  return undefined;
};

export const normalizeExpenseInvoiceDraftBlockReason = (
  value: ExpenseInvoiceDraftBlockReasonDto | undefined
): ExpenseInvoiceDraftBlockReason =>
  parseExpenseInvoiceDraftBlockReason(value) ?? ExpenseInvoiceDraftBlockReason.None;

export const shouldShowExpenseInvoiceDraftBlockReason = (
  status: ExpenseInvoiceStatus,
  draftBlockReason: ExpenseInvoiceDraftBlockReasonDto | undefined
): boolean =>
  status === ExpenseInvoiceStatus.Draft &&
  normalizeExpenseInvoiceDraftBlockReason(draftBlockReason) !== ExpenseInvoiceDraftBlockReason.None;

export const getExpenseInvoiceDraftBlockReasonLabel = (
  draftBlockReason: ExpenseInvoiceDraftBlockReasonDto | undefined
): string => {
  const normalizedDraftBlockReason = normalizeExpenseInvoiceDraftBlockReason(draftBlockReason);

  return EXPENSE_INVOICE_DRAFT_BLOCK_REASON_LABELS[normalizedDraftBlockReason];
};
